import { defineAction } from '~/prix'
import { z } from 'zod'
import topByRelevanceAction from './insightTopByRelevance.action.json' with { type: 'json' }
import { ALERT_PRESET_BASES, ALERT_PRESET_OUTCOMES, toAlertType } from '~/packages/variable/spaceTime.data'

const normalizeStringArrayInput = (value: unknown) => {
  if (value == null) {
    return undefined
  }

  const values = Array.isArray(value) ? value : [value]

  const normalizedValues = values
    .flatMap(currentValue => String(currentValue).split(','))
    .map(currentValue => currentValue.trim())
    .filter(Boolean)

  return normalizedValues.length > 0 ? normalizedValues : undefined
}

const stringArrayInputZod = z.preprocess(
  normalizeStringArrayInput,
  z.array(z.string().trim().min(1)).optional(),
)

const alertPresetOptions = [
  'with-alert',
  'without-alert',
  ...ALERT_PRESET_BASES.flatMap(base => ALERT_PRESET_OUTCOMES.map(outcome => toAlertType(outcome, base))),
] as [string, ...string[]]

export const topByRelevanceInputZod = z.object({
  delimitation: z.string().trim().optional(),
  variableKeys: stringArrayInputZod,
  variablePresetKeys: stringArrayInputZod,
  alertType: stringArrayInputZod,
  alertPreset: z.enum(alertPresetOptions).optional(),
  limit: z.number().int().positive().optional(),
  offset: z.number().int().min(0).optional(),
  fallbackToGlobal: z.boolean().optional(),
})

const topByRelevanceDefinition = defineAction({
  ...topByRelevanceAction,
  input: topByRelevanceInputZod,
  output: z.object({
    items: z.array(z.object({}).passthrough()),
    source: z.enum(['filtered', 'global']),
  }),
  cache: () => {
    return {
      back: {
        expirationMsForFallback: 1000 * 60 * 60 * 24 * 2,
        expirationMsForUpdate: 1000 * 60 * 5,
      },
      front: {
        expirationMsForFallback: 1000 * 60 * 60 * 24 * 5,
        expirationMsForUpdate: 1000 * 60 * 5,
      },
    }
  },
})

export default topByRelevanceDefinition
